import { useMediaQuery } from 'react-responsive';
import { Col } from 'components/Base/Grid';
import Image from 'components/Base/Image';
import logo from 'assets/logo.svg';
import pets from 'assets/pets.png';
import { Screens } from 'core/CssVariables';
import { SPage, SRow } from './style';
import { TWebLayoutProps } from '../../type';

const WebLayout = ({ children }: TWebLayoutProps) => {
  const isSmall = useMediaQuery({
    query: `(max-height: ${Screens.ScreensSMM})`,
  });

  return (
    <SRow>
      <Col className="h-100 left" span={12}>
        <Col className="banner-container">
          <Image src={logo} alt="opp-logo" className="logo" />
          <Image src={pets} alt="pets" className="pets" />
        </Col>
      </Col>
      <Col className="h-100 right" span={12}>
        <SPage $isSmall={isSmall}>
          <div className="content-container">{children}</div>
        </SPage>
      </Col>
    </SRow>
  );
};

export default WebLayout;
